export const MONEY_LINE_TOTAL_POINTS = {
    name: 'MONEY_LINE_TOTAL_POINTS',
    code: '203'
};
export const SPREAD_TOTAL_POINTS = {
    name: 'SPREAD_TOTAL_POINTS',
    code: '204'
};
export const TOTAL_POINTS_GROUP = {
    name: 'TOTAL_POINTS_GROUP',
    code: '149'
};
export const WINNING_MARGIN = {
    name: 'WINNING_MARGIN',
    code: '202'
};
export const MONEYLINE = {
    name: 'MONEYLINE',
    code: '142'
};export const TOTAL_POINTS_OVER_UNDER = {
    name: 'TOTAL_POINTS_OVER_UNDER',
    code: '141'
};
export const SPREAD = {
    name: 'SPREAD',
    code: '140'
};

export const ALL_BASKETBALL_MARKETS = [
    SPREAD, MONEYLINE, TOTAL_POINTS_OVER_UNDER, WINNING_MARGIN, TOTAL_POINTS_GROUP, MONEY_LINE_TOTAL_POINTS, SPREAD_TOTAL_POINTS
];



// WEBPACK FOOTER //
// ./src/ui-modules/sports-book/modules/basketball/constants/marketTypes.js